// Dialog visibility flags for BuildSurvey. Theming dialog flags have moved
// to useThemingState. Setters for publish/pause/resume/restart/finish are
// consumed by useSurveyLifecycle, so useDialogState() must be called before
// useSurveyLifecycle() in build.js.

import { useState } from "react";

export function useDialogState() {
    const [showSettingsDialog, setShowSettingsDialog] = useState(false);
    const [showQuestionDeleteDialog, setShowQuestionDeleteDialog] =
        useState(false);
    const [showProcessDialog, setShowProcessDialog] = useState(false);
    const [showPublishDialog, setShowPublishDialog] = useState(false);
    const [showPauseDialog, setShowPauseDialog] = useState(false);
    const [showResumeDialog, setShowResumeDialog] = useState(false);
    const [showRestartDialog, setShowRestartDialog] = useState(false);
    const [showFinishDialog, setShowFinishDialog] = useState(false);
    const [showConfirmReportDialog, setShowConfirmReportDialog] =
        useState(false);
    const [
        showRespondentResponseSentimentListDialog,
        setShowRespondentResponseSentimentListDialog,
    ] = useState(false);
    const [
        showResponsesSentimentListDialog,
        setShowResponsesSentimentListDialog,
    ] = useState(false);
    const [showTheming, setShowTheming] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);

    return {
        showSettingsDialog,
        setShowSettingsDialog,
        showQuestionDeleteDialog,
        setShowQuestionDeleteDialog,
        showProcessDialog,
        setShowProcessDialog,
        showPublishDialog,
        setShowPublishDialog,
        showPauseDialog,
        setShowPauseDialog,
        showResumeDialog,
        setShowResumeDialog,
        showRestartDialog,
        setShowRestartDialog,
        showFinishDialog,
        setShowFinishDialog,
        showConfirmReportDialog,
        setShowConfirmReportDialog,
        showRespondentResponseSentimentListDialog,
        setShowRespondentResponseSentimentListDialog,
        showResponsesSentimentListDialog,
        setShowResponsesSentimentListDialog,
        showTheming,
        setShowTheming,
        openDrawer,
        setOpenDrawer,
    };
}
